import User from '@interfaces/user.interface'

export const simpleUser: User | any = {
  iss: 'https://securetoken.google.com/squid-hub',
  aud: 'squid-hub',
  auth_time: 1692056442,
  user_id: 'google-oauth2|UCAseoTtmk1zDyK-fLTpCRNw',
  sub: 'DZ8JBAmsmcdvSwLNeSaphHi7R1J3',
  iat: 1692056442,
  exp: 1692060042,
  email: 'wanderson.maranhao@squidit.com.br',
  email_verified: true,
  firebase: {
    identities: {
      email: ['wanderson.maranhao@squidit.com.br'],
    },
    sign_in_provider: 'password',
  },
  uid: 'DZ8JBAmsmcdvSwLNeSaphHi7R1J3',
  squidId: '051f63162c7a',
  instagram: [],
  twitter: [],
  tiktok: [],
  youtube: [
    {
      id: 'UCAseoTtmk1zDyK-fLTpCRNw',
      googleId: 'UCAseoTtmk1zDyK-fLTpCRNw',
      exists: 1,
      searchable: 1,
      notSearchReason: null,
      email: null,
      channelTitle: 'Dev4ever',
      username: 'Dev4ever',
      picture: 'https://storage.googleapis.com/squid-profile-pictures/UCAseoTtmk1zDyK-fLTpCRNw.jpg',
      fullName: null,
      description: null,
      bio: null,
      customUrl: '@dev4ever966',
      country: '',
      since: '2020-03-13T00:08:00.000Z',
      followers: 1,
      subscribers: 1,
      engagementRate: 0.125,
      engagementRatePositive: 0.0625,
      engagementRateNegative: 0,
      viewsRate: 0,
      viewsMedian: 4.5,
      comments: 0,
      identificationComments: 1,
      identificationLikes: 1,
      identificationDislikes: 0,
      averageComments: 0.5,
      averageLikes: 0.5,
      averageDislikes: 0,
      shares: 0,
      averageShares: 0,
      commentLikesRate: 1,
      commentViewsRate: 0.0625,
      averageViewsDuration: 0,
      averageViewPercentage: 0,
      averageVideoDuration: 22.5,
      videoEffectiveReach: 4.5,
      videos: 2,
      identificationVideos: 2,
      views: '9',
      identificationViews: 9,
      privacyStatus: 'public',
      language: null,
      createdAt: '2022-03-04T18:46:20.000Z',
      updatedAt: '2023-07-26T18:40:15.000Z',
      logstashProcessedAt: null,
      macro: 0,
      brandUser: null,
    },
  ],
  profileadditionalinfo: {
    profileId: '051f63162c7a',
    loginUid: 'DZ8JBAmsmcdvSwLNeSaphHi7R1J3',
    email: 'wanderson.maranhao@squidit.com.br',
    document: '39145083029',
    name: 'Wanderson Sales Pereira',
    blog: '',
    birthday: '1993-12-18',
    gender: null,
    phone: '5585992961219',
    zipcode: '60870220',
    address: 'Rua Dalva de Oliveira',
    addressNumber: '861',
    complement: '',
    city: 'Fortaleza',
    neighborhood: 'Conjunto Palmeiras',
    uf: 'CE',
    country: 'BR',
    registeredFromSource: 'hub',
    registeredFromCampaign: null,
    registeredFromMedium: null,
    createdAt: '2021-10-13T23:05:12.000Z',
    updatedAt: '2023-08-14T23:40:10.000Z',
    allowSMS: 1,
    allowWhatsapp: 1,
    allowSuggestionEmail: 1,
    isPersonAccount: 1,
    documentType: 'CPF',
    hasSkip: 0,
    language: 'en',
    phoneValid: 1,
    phoneValidCode: null,
    phoneValidCodeCreatedAt: null,
    race: 1,
    registeredFromAdId: null,
    registeredFromContent: null,
    registeredFromAdName: null,
    portalRegistration: 0,
    agent: 0,
    showWarning: 0,
    scenario: 'cen3',
    updateAddress: 0,
    nationality: 'BR',
    allowBrandLovers: 0,
    allowAffiliates: 0,
    allowResearch: 1,
  },
  banks: [
    {
      id: 63453,
      profileId: '051f63162c7a',
      bankCode: '237',
      bankName: 'Banco Bradesco S.A.',
      bankAccountNumber: '0502693',
      bankAccountDigit: '8',
      bankAccountAgency: '0713',
      bankAccountType: 'checking',
      bankOperationCode: '',
      holderDocument: '39145083029',
      holderOpeningDate: null,
      holderName: 'Wanderson Sales Maranhão',
      holderTradingName: '',
      isPersonAccount: 1,
      createdAt: '2022-06-30T16:48:14.000Z',
      updatedAt: '2022-12-22T16:42:17.000Z',
      nationalDocument: '2008009027579',
      recordEmployment: '12067836392',
      companyName: '',
      fantasyName: '',
      companyOpeningDate: null,
      typeOfBusiness: '',
      paymentType: 'rpa',
      companyUf: '',
      companyCity: '',
      companyLegalNature: '',
      companyDocument: '',
      bankAccountAgencyDigit: '',
      verificationStatus: null,
      verificationId: null,
      verificatedAt: null,
    },
  ],
  profilewhitelabels: [
    {
      _id: '622f466a3276d7001213e9d0',
      name: '',
      domains: [''],
      images: {
        favicon: {
          url: '',
        },
        logo: {
          url: '',
        },
      },
    },
    {
      _id: '62e3ef2bb9a054291dcc5697',
      name: '',
      domains: [''],
      images: {
        favicon: {
          url: '',
        },
        logo: {
          url: '',
        },
      },
    },
    {
      _id: '5f28435e11cfbb0011d97653',
      name: '',
      domains: [''],
      images: {
        favicon: {
          url: '',
        },
        logo: {
          url: '',
        },
      },
    },
    {
      _id: '611ac8b14de7c20011502084',
      name: '',
      domains: [''],
      images: {
        favicon: {
          url: '',
        },
        logo: {
          url: '',
        },
      },
    },
    {
      _id: '5f28435e11cfbb0011d97653',
      name: 'Consultora Natura',
      domains: ['consultoranatura.squidit.com.br'],
      images: {
        favicon: {
          url: 'https://storage.googleapis.com/squid-landing-pages/5f28435e11cfbb0011d97653/webapp-favicon',
        },
        logo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/5f28435e11cfbb0011d97653/webapp-logo',
        },
        negativeLogo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/5f28435e11cfbb0011d97653/webapp-negativeLogo',
        },
        backgroundDesktop: {
          url: '',
        },
        backgroundMobile: {
          url: '',
        },
      },
    },
    {
      _id: '611ac8b14de7c20011502084',
      domains: ['consultorasnaturachile.squidit.com.br', 'consultora.natura.cl', 'stg-consultorasnaturachile.squidit.com.br'],
      name: 'Consultoras Natura Chile',
      images: {
        favicon: {
          url: 'https://storage.googleapis.com/squid-landing-pages/611ac8b14de7c20011502084/webapp-favicon',
        },
        logo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/611ac8b14de7c20011502084/webapp-logo',
        },
        negativeLogo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/611ac8b14de7c20011502084/webapp-negativeLogo',
        },
        backgroundDesktop: {
          url: '',
        },
        backgroundMobile: {
          url: '',
        },
      },
    },
    {
      _id: '622f466a3276d7001213e9d0',
      domains: ['time.squidit.com.br'],
      name: 'Time Squid',
      images: {
        favicon: {
          url: 'https://storage.googleapis.com/squid-landing-pages/622f466a3276d7001213e9d0/webapp-favicon',
        },
        logo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/622f466a3276d7001213e9d0/webapp-logo',
        },
        negativeLogo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/622f466a3276d7001213e9d0/webapp-negativeLogo',
        },
        backgroundDesktop: {
          url: '',
        },
        backgroundMobile: {
          url: '',
        },
      },
    },
    {
      _id: '62e3ef2bb9a054291dcc5697',
      domains: ['grupoboticario.squidit.com.br', 'boticario.squidit.com.br', 'revendedoresoboticario.squidit.com.br'],
      name: 'Influenciadores da Beleza',
      images: {
        favicon: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-negativeLogo',
        },
        logo: {
          url: 'https://storage.googleapis.com/squid-dev/62e3ef2bb9a054291dcc5697/webapp-logo',
        },
        negativeLogo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-logo',
        },
        backgroundDesktop: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-backgroundDesktop',
        },
        backgroundMobile: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-backgroundMobile',
        },
      },
    },
    {
      _id: '',
      name: 'Squid',
      domains: ['app.squidit.com.br'],
      images: {
        favicon: {
          url: '',
        },
        logo: {
          url: '',
        },
      },
    },
  ],
  identities: [
    {
      provider: 'google-oauth2',
      connection: 'google-oauth2',
      name: 'Dev4ever',
      username: 'Dev4ever',
      picture: 'https://storage.googleapis.com/squid-profile-pictures/UCAseoTtmk1zDyK-fLTpCRNw.jpg',
      id: 'UCAseoTtmk1zDyK-fLTpCRNw',
      user_id: 'UCAseoTtmk1zDyK-fLTpCRNw',
      email: null,
      google_id: 'UCAseoTtmk1zDyK-fLTpCRNw',
    },
  ],
  picture: 'https://storage.googleapis.com/squid-profile-pictures/UCAseoTtmk1zDyK-fLTpCRNw.jpg',
  statusProviders: {
    instagram: [],
    twitter: [],
    tiktok: [],
    'google-oauth2': [
      {
        ok: true,
        id: 'UCAseoTtmk1zDyK-fLTpCRNw',
        tokenExpired: false,
      },
    ],
  },
  providerAuthenticated: 'yt',
}

export const brazilianUser: User = {
  ...simpleUser,
  profileadditionalinfo: {
    ...simpleUser.profileadditionalinfo,
    documentType: 'CPF',
    nationality: 'BR',
    country: 'BR',
  },
}

export const chileanUser: User = {
  ...simpleUser,
  profileadditionalinfo: {
    ...simpleUser.profileadditionalinfo,
    documentType: 'RUT',
    nationality: 'CH',
    country: 'CH',
  },
}

export const internationalUser: User = {
  ...simpleUser,
  profileadditionalinfo: {
    ...simpleUser.profileadditionalinfo,
    documentType: 'International',
    nationality: 'CN',
    country: 'CN',
  },
}

export const userWithoutGender: User = {
  ...simpleUser,
  profileadditionalinfo: {
    ...simpleUser.profileadditionalinfo,
    gender: null,
  },
}
